module.exports = __webpack_public_path__ + "static/media/118-malasya.11d7ac21.svg";